export { SubmitBatch as default } from '@/screens/batches/SubmitBatch'
